import {
	START_FETCH_CAPTCHA,
	FETCH_CAPTCHA_SUCCESS,
	FETCH_CAPTCHA_FAILED,

	START_DETECT_CAPTCHA,
	DETECT_CAPTCHA_SUCCESS,
	DETECT_CAPTCHA_FAILED,
} from './action-types';

export function fetchCaptchaAction() {
	return {
		type: START_FETCH_CAPTCHA,
	};
}

export function fetchCaptchaSuccessAction(data) {
	return {
		type: FETCH_CAPTCHA_SUCCESS,
		data,
	};
}

export function fetchCaptchaFailedAction(error, errorMessage) {
	return {
		type: FETCH_CAPTCHA_FAILED,
		error,
		errorMessage,
	};
}

export function detectCaptchaAction() {
	return {
		type: START_DETECT_CAPTCHA,
	};
}

export function detectCaptchaSuccessAction() {
	return {
		type: DETECT_CAPTCHA_SUCCESS,
	};
}

export function detectCaptchaFailedAction(error, errorMessage) {
	return {
		type: DETECT_CAPTCHA_FAILED,
		error,
		errorMessage,
	};
}
